





import {Component, Vue, Watch} from 'vue-property-decorator'
import kepler from '../../../lib/kepler_sdk/kepler';
import Table from "@/views/UI/Table.vue";

@Component({
    components: {Table},
})
export default class People extends Vue {
    public items = []
    public endpoint = "subscriptions";
    public detail = "subscription";
    public headers = [
        {text: 'ID', value: 'id'},
        {text: 'PLAN', value: 'plan.name'},
        {text: 'DRIVERS', value: 'plan.max_drivers'},
        {text: 'BILLING_CYCLE', value: 'plan.billing_cycle'},
        {text: 'EXPIRY', value: 'next_due_date'},
        {text: 'COST', value: 'plan.cost'},


    ]

    public options = {
        page: 1,
        itemsPerPage: 20
    }

    public loading = true

    public totalItems = null
    public totalPages = null

}
